import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  userPermission: string[] = [];
  isAdmin:boolean = false;
  isAdminOrEnt: boolean = false;
  // 控制是否显示 Basic 菜单项（默认隐藏，待权限拉取成功后再更新，避免闪烁）
  isBasicVisible: boolean = false;
  isDownloaderPro: boolean = false;
  isAnalyzerPro: boolean = false;
  canSeeRtkExpert: boolean = false;
  canSeeExternalConnections: boolean = false;
  isDemo = false;

  constructor(public auth: AuthService, private userService: UserService, private router: Router, private perms: PermissionService) {
    // 在路由切换后刷新权限，确保不同页面都能正确显示管理员菜单
    this.router.events.subscribe(ev => {
      if (ev instanceof NavigationEnd) {
        this.loadPermissions(false);
      }
    });
  } 


  ngOnInit(): void {
    this.loadPermissions(true);
    // 订阅权限变化，实时更新菜单显隐
    this.perms.permissionsChanged$.subscribe(_ => this.applyPermissions());
  }  

  logOut(): void {
    this.auth.logOut();
    // 如果需要，这里还可以添加一些逻辑来处理登出后的用户界面变化，如重定向等
  }

  retrieveUserPermissions(): void {
    this.loadPermissions(false);
  }

  private loadPermissions(firstTry: boolean): void {
    // 改为本地解析 JWT
    this.perms.ensureFresh();
    this.applyPermissions();
  }

  private applyPermissions(): void {
    this.userPermission = this.perms.getPermissions();
    this.isAdmin = this.perms.isAdmin();
    this.isAdminOrEnt = this.perms.isAdminOrEnt();
    this.isBasicVisible = this.perms.hasAny(['ntrip-pro', 'ntrip-basic']);
    this.isDownloaderPro = this.perms.hasAny(['downloader-pro']);
    this.isAnalyzerPro = this.perms.hasAny(['analyzer-pro']);
    this.isDemo = this.perms.has('demo');
    this.canSeeRtkExpert = this.perms.hasAny(['downloader-pro', 'analyzer-pro', 'demo']);
    this.canSeeExternalConnections = this.perms.hasAny(['downloader-pro', 'analyzer-pro', 'demo']);
  }

}
